import { DataAnalyticsTaggingEvent, DataAnalyticsTaggingEvents, DataAnalyticsTaggingEventType } from '@tdwb/core';
import { TransferType } from './transfers.domain';

export class TransfersAnalytics {

  static transfersModalTaggingEvents: DataAnalyticsTaggingEvents = {
    modalTransfersCash: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'cash',
        subSection1: 'transfers',
        subSection2: 'cash',
        customPageName: 'wb_modal-transfers-cash'
      },
      process: {
        processName: 'tdw:wbt:cash:transfer'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalTransfersCash_Review: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'cash-review',
        subSection1: 'transfers',
        subSection2: 'cash-review',
        customPageName: 'wb_modal-transfers-cash-review'
      },
      process: {
        processName: 'tdw:wbt:cash:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:start'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalTransfersCash_Confirmation: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'cash-confirmation',
        subSection1: 'transfers',
        subSection2: 'cash-confirmation',
        customPageName: 'wb_modal-transfers-cash-confirmation'
      },
      process: {
        processName: 'tdw:wbt:cash:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:complete'
      }
    },
    modalTransfersOfi: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'ofi',
        subSection1: 'transfers',
        subSection2: 'ofi',
        customPageName: 'wb_modal-transfers-ofi'
      },
      process: {
        processName: 'tdw:wbt:ofi:transfer'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalTransfersOfi_Review: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'ofi-review',
        subSection1: 'transfers',
        subSection2: 'ofi-review',
        customPageName: 'wb_modal-transfers-ofi-review'
      },
      process: {
        processName: 'tdw:wbt:ofi:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:start'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalTransfersOfi_Confirmation: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'ofi-confirmation',
        subSection1: 'transfers',
        subSection2: 'ofi-confirmation',
        customPageName: 'wb_modal-transfers-ofi-confirmation'
      },
      process: {
        processName: 'tdw:wbt:ofi:transfer',
        processType: 'tdw:wbt:non-recurring:transfer:complete'
      }
    },
    modalTransfersSecurities: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'securities',
        subSection1: 'transfers',
        subSection2: 'securities',
        customPageName: 'wb_modal-transfers-securities'
      }
    }
  };

  static transfersPageTaggingEvents: DataAnalyticsTaggingEvents = {
    pageTransfersDereg: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'dereg',
        subSection1: 'transfers',
        subSection2: 'dereg',
        customPageName: 'wb_transfers-withdrawal-rsp-resp'
      }
    },
    pageTranfersWithdrawalResp: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'resp withdrawal',
        subSection1: 'transfers',
        subSection2: 'resp withdrawal',
        customPageName: 'wb_transfers-withdrawal-resp'
      },
      process: {
        processName: 'tdw:wbt:RESP',
        processType: 'tdw:wbt:resp:start'
      }
    },
    pageTranfersWithdrawalRsp: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'rrsp withdrawal',
        subSection1: 'transfers',
        subSection2: 'rrsp withdrawal',
        customPageName: 'wb_transfers-withdrawal-rrsp'
      },
      process: {
        processName: 'tdw:wbt:RRSP',
        processType: 'tdw:wbt:rrsp:start'
      }
    },
    pageTransfersTransfers_OverviewTransfers_Entry: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'overview',
        subSection1: 'transfers',
        subSection2: 'overview',
        customPageName: 'wb_transfers-overview'
      }
    },
    pageTransfersTransfers_OverviewTransfers_Status: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'status',
        subSection1: 'transfers',
        subSection2: 'status',
        customPageName: 'wb_transfers-status'
      }
    }
  };

  static getTransfersPageStepEvent(name: string,
                                   subSection1: string,
                                   subSection2: string,
                                   customPageName: string,
                                   processName: string): DataAnalyticsTaggingEvent {
    const eventData: DataAnalyticsTaggingEvent = {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name,
        subSection1,
        subSection2,
        customPageName
      },
      process: {
        processName
      }
    }
    if (name.includes('confirmation')){
      eventData.process.processType = `tdw:wbt:${name.split(' ')[0]}:complete`
    }
    return eventData;
  }

  static getTransfersPageStepEvents(pageName: string, customPageName: string, processName: string): DataAnalyticsTaggingEvent {
    return {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: pageName,
        subSection1: 'transfers',
        subSection2: pageName,
        customPageName: `wb_transfers-resp-${customPageName}`
      },
      process: {
        processName: `tdw:wbt:RESP:${processName} withdrawal`
      }
    }
  }

  static getTransferCardClickEventName(transferType: TransferType): string {
    let eventName = '';

    switch (transferType) {
      case 'cash':
        eventName = 'transfer cash';
        break;
      case 'ofi':
        eventName = 'transfer ofi';
        break;
      case 'deregisteredWithdraw':
        eventName = 'RRSP RESP withdrawals';
        break;
      case 'securities':
        eventName = 'transfer securities';
        break;
    }

    return eventName;
  }

  static taggingEvents: DataAnalyticsTaggingEvents = {
    ...this.transfersModalTaggingEvents,
    ...this.transfersPageTaggingEvents
  };
}
